import apiClient from "../client";

export interface Job {
  _id: string;
  jobName: string;
  jobId: string;
  location: string[];
  requiredSkills: string[];
  experienceRequired: string[];
  description: string;
  jobCategory: string;
  numberOfPositions: number;
  region: string;
  status: string;
}

interface JobFilter {
  role?: string; // jobName
  description?: string;
  category?: string;
  location?: string;
  status?: string;
  globalSearch?: string;
  page?: number;
  limit?: number;
  orderBy?: string;
  orderDirection?: "ASC" | "DESC";
}


const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

export const getJobList = async (filters?: JobFilter): Promise<Job[]> => {
  try {
    const search: any = {};

    if (filters?.role) search.jobName = filters.role;
    if (filters?.description) search.description = filters.description;
    if (filters?.location) search.location = filters.location;
    if (filters?.status) search.status = filters.status;
    if (filters?.globalSearch) search.globalSearch = filters.globalSearch;

    const payload = {
      limit: filters?.limit || 5,
      page: filters?.page || 1,
      orderBy: filters?.orderBy || "updatedAt",
      orderDirection: filters?.orderDirection || "ASC",
      search: Object.keys(search).length ? search : undefined, // omit if empty
    };

    const res = await apiClient.post(`${API_BASE_URL}/intron/job/list`, payload);
    const records = res.data?.data?.items?.[0]?.records || [];
    return records;
  } catch (err) {
    console.error("Error fetching job list:", err);
    return [];
  }
};

